import { graphql } from "~/gql";

export const BEDROCK_CHECK_MATTER_TITLE_IS_DESCRIPTIVE = graphql(/* GraphQL */ `
  query BedrockCheckMatterTitleIsDescriptive($matterTitle: String!) {
    bedrockCheckMatterTitleIsDescriptive(matterTitle: $matterTitle)
  }
`);
